import HttpService from "./HttpService";
const API_URL = "/team";

const TeamService = {
  fetchTeams: async () => {
    try {
      const response = await HttpService.get(`${API_URL}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching teams:", error);
      throw error;
    }
  },
  fetchTeamsPaginated: async (pageConfig) => {
    const pageConfigParams = new URLSearchParams(pageConfig);
    try {
      const response = await HttpService.get(
        `${API_URL}-paginated?${pageConfigParams}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching teams:", error);
      throw error;
    }
  },

  addTeam: async (teamData) => {
    // try {
    const response = await HttpService.post(API_URL, teamData);
    return response.data;
    // } catch (error) {
    //     console.error('Error adding team:', error);
    //     throw error;
    // }
  },

  updateTeam: async (teamId, updatedTeam) => {
    try {
      const response = await HttpService.put(
        `${API_URL}/${teamId}`,
        updatedTeam
      );
      return response.data;
    } catch (error) {
      console.error("Error updating team:", error);
      throw error;
    }
  },

  deleteTeam: async (teamId) => {
    try {
      const response = await HttpService.delete(`${API_URL}/${teamId}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting team:", error);
      throw error;
    }
  },
};

export default TeamService;
